export default function getResource(label, vars = []) {
    const resources = { all: 'Tous' };

    return resources[label];
}
